import { AlertTriangle } from "lucide-react";

export function Disclaimer({ compact = false, className = "" }) {
  if (compact) {
    return (
      <p className={`text-[11px] leading-relaxed text-muted-foreground ${className}`} data-testid="disclaimer-compact">
        AI signals are informational and probabilistic — not guarantees of future performance. Trading involves
        significant risk of loss. Past performance does not guarantee future results.
      </p>
    );
  }
  return (
    <div className={`flex gap-3 rounded-xl border border-warning/30 bg-warning/5 p-4 ${className}`} data-testid="disclaimer-block">
      <AlertTriangle className="h-5 w-5 shrink-0 text-warning" />
      <div className="text-xs leading-relaxed text-muted-foreground space-y-1">
        <p>Trading involves significant risk and you may lose money. AI-generated signals are informational and
          probabilistic and are not guarantees of future performance.</p>
        <p>Past performance does not guarantee future results. Always consider your own risk tolerance and financial
          circumstances. KREONIS does not provide regulated investment advice or custody user funds.</p>
      </div>
    </div>
  );
}
